import { partition, concat } from "lodash";
import { useState } from "react";
import { getCombinedSortedTags } from "./sub-components/ExpandableBadgeList.utils";

type EntityTagRow = { tagId?: unknown; [key: string]: unknown };
type NewTagRow = { id?: unknown; [key: string]: unknown };

const useSelectedValues = (tags: EntityTagRow[], entityType?: string) => {
  const [newTags, setNewTags] = useState<NewTagRow[]>([]);
  const [existingTags, newlyAddedTags] = partition(
    tags,
    (tag) => !newTags.find((newTag) => newTag.id === tag.tagId)
  );
  const addTag = (tag: NewTagRow) => {
    setNewTags([...newTags, tag]);
  };

  return {
    addTag,
    newTags,
    tags: concat(
      getCombinedSortedTags(existingTags, entityType),
      newlyAddedTags
    ),
  };
};

export default useSelectedValues;
